export default {
  items: [
    // {
    //   name: 'Accueil',
    //   url: process.env.VUE_APP_BASE_URL,
    //   icon: 'icon-home',
    //   badge: {
    //     variant: 'primary'
    //   }
    // }
  ]
}
